const CustomContactsFilters = [
  {
    name: 'Custom contacts',
    searchState: 'activeSearch',
    pages: ['CustomContacts'],
    filterName: 'categories',
    options: [
      {
        name: 'Custom Contact',
        selected: true,
      },
    ],
    operator: 'str_eq',
    hidden: true,
    notUseFromLocalStorage: true,
  },
];

export default CustomContactsFilters;
